export const API_URL = document.cms_site_url + '/api/';


// WEBPACK FOOTER //
// ./assets/vue/apps/participate/constants.js